import { computed, observable } from "mobx";
import type { EntityValidationRules } from "services/validationService";
import Notice, { SignatureType } from "./notice";
import { CountryIdValidationRules, LicensePlateValidationRules } from "./orderItem";
import CustomerRefundApplicationReason from "../entities/customerRefundApplicationReason";
import CustomerRefundApplicationOrderSourceType from "../entities/customerRefundApplicationOrderSourceType";
import Vehicle from "./vehicle";

export const NoticeTechnicalLicenseRules: EntityValidationRules<Notice> = {
  _technicalLicenseFilesBase64: {
    requiredIf: {
      condition: (entity: Notice) => entity._signatureType === SignatureType.DataBox,
      customMessage: "documentUploadRequired",
    },
  },
};

export default class RefundRequestNotice extends Notice {
  @observable
  licensePlate: string;

  @observable
  countryId: string;

  @observable
  vehicle: Vehicle = new Vehicle();

  @observable
  reason: CustomerRefundApplicationReason;

  @observable
  otherReasonText?: string;

  @observable
  bankAccount?: string;

  @observable
  chargeOrderSourceType: CustomerRefundApplicationOrderSourceType = CustomerRefundApplicationOrderSourceType.Eshop;

  @computed
  get rules(): EntityValidationRules<RefundRequestNotice> {
    return {
      ...LicensePlateValidationRules,
      ...CountryIdValidationRules,
      ...NoticeTechnicalLicenseRules,
      reason: {
        required: true,
      },
      chargeOrderSourceType: {
        required: true,
      },
      otherReasonText: {
        requiredIf: {
          condition: (entity: RefundRequestNotice) => entity.reason === CustomerRefundApplicationReason.Other,
        },
      },
      bankAccount: {
        requiredIf: {
          condition: (entity: RefundRequestNotice) =>
            entity.chargeOrderSourceType === CustomerRefundApplicationOrderSourceType.Salespoint,
        },
        isLength: {
          max: 42,
        },
        // TODO: We don't have translations for the account number validations
        // isBankAccountNumber: {
        //   bankCode: true,
        //   prefix: true,
        // },
      },
    };
  }
}
